<template>
  <div class="issuer-select">

    <multiselect
        ref="select"
        v-model="selectedOption"
        :options="options"
        :loading="loading"
        :internal-search="true"
        :clearable="clearable"
        :placeholder="placeholder"
        :label="labelKey"
        :track-by="valueKey"
    >

      <template #beforeList>
        <li class="multiselect__element">
          <span class="create-item" @click.stop="openCreateModal">
            ➕ Создать новый орган выдачи
          </span>
        </li>
      </template>

      <template #noResult>
        <span v-if="!loading">Ничего не найдено</span>
        <span v-else>Загрузка...</span>
      </template>

    </multiselect>

    <!-- MODAL -->
    <div v-if="showModal" class="modal-overlay">

      <div class="modal-box">

        <h5 class="mb-3">Создать орган выдачи</h5>

        <input
            v-model="newName"
            class="form-control"
            placeholder="Название"
            @keyup.enter="createIssuer"
        />

        <div class="modal-actions">

          <button class="btn btn-secondary" @click="closeModal">
            Отмена
          </button>

          <button
              class="btn btn-primary"
              :disabled="loadingCreate"
              @click="createIssuer"
          >
            Создать
          </button>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from "@/axios"
import Multiselect from "vue-multiselect"

export default {

  name: "PasportIssuerSelect",

  components: { Multiselect },

  props: {
    modelValue: null,
    url: { type: String, required: true },
    createUrl: { type: String, required: true },
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: "Выберите..." },
    valueKey: { type: String, default: "id" },
    labelKey: { type: String, default: "name" }
  },

  emits: ["update:modelValue"],

  data() {
    return {
      options: [],
      loading: false,
      loadingCreate: false,
      showModal: false,
      newName: "",
      selectedOption: null
    }
  },

  watch: {

    // когда приходит ID извне
    modelValue: {
      immediate: true,
      handler(val) {

        if (!val) {
          this.selectedOption = null
          return
        }

        const found = this.options.find(
            o => o[this.valueKey] === val
        )

        if (found) {
          this.selectedOption = found
        }

      }
    },

    // когда пользователь выбирает
    selectedOption(val) {

      if (!val) {
        this.$emit("update:modelValue", null)
        return
      }

      this.$emit("update:modelValue", val[this.valueKey])

    }

  },
  mounted() {
    this.load()
  },
  methods: {

    async load() {

      if (this.options.length) return

      this.loading = true

      try {

        const { data } = await axios.get(this.url)

        this.options = data

        // если есть переданный id — выбираем объект
        if (this.modelValue) {

          const found = this.options.find(
              o => o[this.valueKey] === this.modelValue
          )

          if (found) {
            this.selectedOption = found
          }

        }

      } catch (e) {

        console.error(e)

      } finally {

        this.loading = false

      }

    },

    openCreateModal() {

      this.$refs.select.deactivate()

      this.showModal = true
      this.newName = ""

    },

    closeModal() {

      this.showModal = false
      this.newName = ""

    },

    async createIssuer() {

      if (!this.newName.trim()) return

      this.loadingCreate = true

      try {

        const { data } = await axios.post(this.createUrl, {
          name: this.newName
        })

        const item = data.data

        this.options.unshift(item)

        this.selectedOption = item

        this.closeModal()

      } catch (e) {

        console.error(e)

      } finally {

        this.loadingCreate = false

      }

    }

  }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

.create-item {
  display: block;
  padding: 10px;
  cursor: pointer;
  font-weight: 600;
  border-bottom: 1px solid #eee;
}

.create-item:hover {
  background: #f5f5f5;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-box {
  background: white;
  padding: 20px;
  width: 350px;
  border-radius: 8px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  gap: 10px;
}

</style>